import React from 'react';
import './machine&deep-learning.css';

const m_learning = () => {
    return (
        <div className="m_learning__wrap">
            <div className="m_learning container">
                <h3 className="m_learning--title">Machine Learning & Deep Learning Track</h3>
                <p className="m_learning--text inner_pages--text">Comprising multiple tracks, this focus area is where leading experts in the rapidly expanding fields of Deep Learning and Machine Learning gather to discuss the latest advances, trends, and models in this exciting field. </p>
                <p className="m_learning--text inner_pages--text">Attend talks, tutorials, and workshops and hear from the creators and top practitioners as they teach the latest models and trends in Machine Learning and Deep Learning to solve problems in business and society.</p>
            </div>
        </div>
    );
};

export default m_learning;